import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar } from '@mui/material';
// hooks
import useOffSetTop from '../../../hooks/useOffSetTop';
import useResponsive from '../../../hooks/useResponsive';
import useCompany from '../../../hooks/useCompany';
// utils
import cssStyles from '../../../utils/cssStyles';
// config
import { HEADER } from '../../../config';
// components
import Logo from '../../../components/Logo';
import Iconify from '../../../components/Iconify';
import { IconButtonAnimate } from '../../../components/animate';
//
import AccountPopover from './AccountPopover';
import AttendancePopover from './AttendancePopover';

// ----------------------------------------------------------------------

const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isOffset' && prop !== 'verticalLayout',
})(({ isOffset, verticalLayout, theme }) => ({
  ...cssStyles(theme).bgBlur(),
  boxShadow: 'none',
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  transition: theme.transitions.create(['width', 'height'], {
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('lg')]: {
    height: HEADER.MAIN_DESKTOP_HEIGHT,
    ...(isOffset && {
      height: HEADER.MAIN_DESKTOP_OFFSET_HEIGHT,
    }),
    ...(verticalLayout && {
      width: '100%',
      height: HEADER.MAIN_DESKTOP_OFFSET_HEIGHT,
      backgroundColor: theme.palette.background.default,
    }),
  },
}));

// ----------------------------------------------------------------------

NavHeader.propTypes = {
  onOpenSidebar: PropTypes.func,
  verticalLayout: PropTypes.bool,
};

export default function NavHeader({ onOpenSidebar, verticalLayout = false }) {
  const { attendableCompany } = useCompany();
  const isOffset = useOffSetTop(HEADER.MAIN_DESKTOP_HEIGHT) && !verticalLayout;
  const hasAttendableCompany = attendableCompany && attendableCompany.length > 0;
  const isDesktop = useResponsive('up', 'lg');

  return (
    <RootStyle isOffset={isOffset} verticalLayout={verticalLayout}>
      <Toolbar
        sx={{
          minHeight: '100% !important',
          px: { lg: 5 },
        }}
      >
        {isDesktop && verticalLayout && <Logo sx={{ mr: 2.5 }} />}

        {!isDesktop && (
          <IconButtonAnimate onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
            <Iconify icon="eva:menu-2-fill" />
          </IconButtonAnimate>
        )}

        <Box sx={{ flexGrow: 1 }} />
        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
          {hasAttendableCompany ? (
            <AttendancePopover />
          ) : (
            <AccountPopover />
          )}
        </Stack>
      </Toolbar>
    </RootStyle>
  );
}
